module.exports = "/static-assets/_next/static/images/rainbowArrow-a41ad725cd4f3533a0dab6c2fa4aff47.png";